export interface Rect {
	x: number;
	y: number;
	w: number;
	h: number;
}

/** Build a positive-size rect from an anchor point and the current pointer point. */
export function normalizeRect(anchorX: number, anchorY: number, pointX: number, pointY: number): Rect {
	return {
		x: Math.min(anchorX, pointX),
		y: Math.min(anchorY, pointY),
		w: Math.abs(pointX - anchorX),
		h: Math.abs(pointY - anchorY),
	};
}

export function rectsOverlap(a: Rect, b: Rect): boolean {
	return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}
